import React, { useState,useEffect } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import Modal from 'react-modal'; // Optional: Install with `npm install react-modal`
import { Link, useNavigate, useParams } from 'react-router-dom';
import { formatUSNumber, MakeAxiosRequest } from "../../utils/handler";
import Loader from '../../Assets/Images/loader.gif';
import paymentfailed from '../../Assets/Images/paymentfailed.png';

const CheckoutForm = ({invoicedata}) => {
     const params = useParams();
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [succeeded, setSucceeded] = useState(false);
    const [paymentError, setPaymentError] = useState(null); // Store payment error
    const [showModal, setShowModal] = useState(false); // Toggle modal visibility
    const [showModal3d, setShowModal3d] = useState(false); // Toggle modal visibility
const [intentId, setIntentId] = useState(null);
const [redirectUrl, setRedirectUrl] = useState('');
    const navigate = useNavigate();
    const [cardDetails, setCardDetails] = useState({});
    const [modalIsOpen, setModalIsOpen] = useState(false);
    // Custom CSS for the modal size
        const customStyles = {
          content: {
            width: '550px', // Adjust width here
            margin: 'auto', // Center the modal
            padding: '0',
            border: 'none',
            overflow :'unset',
           
          },
        };
            const cardElementOptions = {
            style: {
                base: {
                    fontSize: '16px',
                    color: '#32325d',
                    '::placeholder': {
                        color: '#aab7c4',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                },
            },
            hidePostalCode: true, // This hides the ZIP code field
            
        };

        const closeModal = () => {
            setModalIsOpen(false);
            setProcessing(false);
            setShowModal(false);
             setPaymentError(null);
        };
            const handleSubmit = async (event) => {
                setProcessing(true);
                event.preventDefault();

                if (!stripe ) {
                    setProcessing(false);
                    return; // Make sure Stripe is loaded
                }

                if (!elements) {
                    setProcessing(false);
                        setError('Card information is required.');
                        return;
                }
                const cardElement = elements.getElement(CardElement);
               // Check if CardElement is empty or invalid
                if (!cardElement || cardElement._empty) {
                    setProcessing(false);
                    setError('Card information is required.');
                    return;
                }
               try {
                     const { token, error: stripeError } = await stripe.createToken(elements.getElement(CardElement));
                   if (stripeError) {
                        // Handle Stripe-specific error
                        setError(stripeError.message || 'An unexpected error occurred with the card.');
                        setProcessing(false);
                        return;
                      }
                    if (!token) {
                        setError('Card information is wrong.');
                        setProcessing(false);
                        return;
                    }
                    const exp_month = token.card.exp_month < 10 ? '0' + token.card.exp_month : token.card.exp_month;
                    const cardInfo = {
                        brand: token.card.brand,
                        last4: token.card.last4,
                        exp_month,
                        exp_year: token.card.exp_year,
                        token: token.id,
                    };

                    // Store the card details in the state
                    setCardDetails(cardInfo);
                } catch (error) {
                    setProcessing(false);
                     setError('There was an issue processing your payment. Please try again later.');
                    console.error(error);
                }
               
                setError(null);

                setModalIsOpen(true);
                setProcessing(false);
            };
        
    

         const handleConfirmPayment = async () => {
                setIsLoading(true);
                const key = params.key; // Replace with your actual key
                try {
                    const cardElement = elements.getElement(CardElement);
                    if (!cardElement) {
                        setPaymentError('Card information is required.');
                                   setIsLoading(false);
                                    setShowModal(true);
                        //setErrorMessage('Card information is required.');
                        return;
                    }
                    // Create payment method and pass it to the backend to create Payment Intent
                    const { error, paymentMethod } = await stripe.createPaymentMethod({
                      type: 'card',
                      card: cardElement,
                    }, {
                      stripeAccount: invoicedata.stripe_acc_id, // Replace with the connected account ID
                    });
                    
                    if (!error) {
                        const key = params.key;
                        
                        const response = await MakeAxiosRequest("post", "/createintent/"+params.key,{invoiceKey:params.key,payment_method: paymentMethod.id});
                        console.log(response);
                            setIntentId(response.paymentintentID);
                        
                           if (response.requiresAction) {
                                setProcessing(false);
                                const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(response.clientSecret, {
                                            payment_method: paymentMethod.id, // Pass the payment method ID here
                                        });
                              
                               if (confirmError) {
                                   setPaymentError(confirmError.message);
                                   setIsLoading(false);
                                    setShowModal(true);
                                   console.log(confirmError.message);
                                } else if (paymentIntent.status === 'succeeded') {
                                   
                                    handleSuccess(paymentIntent.id);
                                }else if (paymentIntent.status === 'requires_payment_method') {
                                    setProcessing(false);
                                     setIsLoading(false);
                                    setPaymentError(paymentIntent.last_payment_error.message);
                                } else if (paymentIntent.status === 'requires_action') {
                                    // Handle 3D Secure authentication here
                                    if (response.action_url != '') {
                                            setIsLoading(false);
                                            setModalIsOpen(false);
                                            setRedirectUrl(response.action_url);
                                            setShowModal3d(true); // Show modal with iframe for 3D Secure
                                        } 

                                    console.log('3D Secure authentication required.');
                                }
                                    
                         
                        }else{
                            
                            if (response.status == 2) {
                                console.log(response.status,'test');
                                 setIsLoading(false);
                                 setPaymentError(response); // Redirect to '/another-page'
                                setShowModal(true);
                            }else{
                                 console.log(response.paymentintentID);
                                 handleSuccess(response.paymentintentID); 
                            }
                            
                        }
                    }
             } catch (err) {
                console.error('Error making payment:', err);
            }

 
             
          
        
    };
   
  useEffect(() => {
    // Function to handle messages from the iframe
    const handleIframeMessage = (event) => {
        console.log(event.origin);
      if (event.origin === 'https://api-dev.swizzlepay.com') { // Replace with your iframe's origin
        console.log('Message from iframe:', event.data);
        if (event.data === 'refreshPage') {
          // Refresh the page or perform other actions
          navigate('/payment/success/'+params.key);
        }
      }
    };

    window.addEventListener('message', handleIframeMessage);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, []);
    const handleSuccess = async(intentId) => {
      // After 3D Secure completion or if it's not required, handle the success
      //console.log('Payment method attached successfully:', setupIntent);
         const key = params.key; // Replace with your actual key
      // Call the API to save the payment method or trigger the next steps
        console.log(intentId);
        const response = await MakeAxiosRequest("post", "/makepayment/"+params.key, {
                invoiceKey: key,intentId:intentId,last4:cardDetails.last4
            });

            if (response.status == 1) {
                 setIsLoading(false);
                 navigate('/payment/success/'+params.key); // Redirect to '/another-page'
            }else if (response.status == 2) {
                 setIsLoading(false);
                 setPaymentError(response); // Redirect to '/another-page'
            } else {
                console.log(response.response.data.message);
                setPaymentError(response.response.data);
                setIsLoading(false);
                setShowModal(true);
                console.error('Unexpected response:', response);
            }
    };
    return (
          <div>
        <form onSubmit={handleSubmit}>
            <CardElement options={cardElementOptions}/>
            {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
            <button className='btn btn-primary w-100 mt-3' type="submit" disabled={!stripe || processing}>
                {processing ? "Processing..." : "Pay"}
            </button>
            
            {succeeded && <div>Payment succeeded!</div>}
        </form>
         {/* Modal Popup */}
      <Modal isOpen={showModal3d} onRequestClose={() => setShowModal3d(false)} style={customStyles}>
       
        {/* 3D Secure Iframe */}
        {redirectUrl && (
            <div className="modal-dialog modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0 p-0">
                        <button 
                          type="button" 
                          className="close-btn" 
                          onClick={() => setShowModal3d(false)}
                        >
                          <span className="material-symbols-outlined">close</span>
                        </button>
                    </div>
            
                    <iframe
                      src={redirectUrl}
                      title="3D Secure Authentication"
                      width="100%"
                      height="500px"
                        sandbox="allow-scripts allow-same-origin allow-forms"
                    />
                  </div>
              </div>
          
        )}

       
      </Modal>
            
          <Modal 
       
              onRequestClose={closeModal} 
              isOpen={modalIsOpen} 
              style={customStyles} // Apply custom styles
              ariaHideApp={false} // Add this line to prevent accessibility issues during development
            >
              <div className="modal-dialog modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                  {isLoading ? (
                    <div className='paymentProcess'>
                      <img src={Loader} className='loader' alt="Loading..." />
                      <h5 className='mb-5'>Processing your payment...</h5>
                    </div>
                  ) : (
                    <>
                      <div className="modal-header border-0 p-0">
                    <button 
                      type="button" 
                      className="close-btn" 
                      onClick={closeModal}
                    >
                      <span className="material-symbols-outlined">close</span>
                    </button>
                  </div>
                  <div className="modal-body p-sm-4 p-3">
                      {(!isLoading && !showModal) && <>
                    <div className="text-center">
                      <h4 className="mb-0" id="paymentDetailsModalLabel">Confirm Payment</h4>
                      <p>Please confirm your payment details before proceeding:</p>
                    </div>
                    <div className="card my-3">
                      <div className="card-body invoice-body p-3">
                        <ul>
                          <li key="invoice-number"><p>Invoice Number</p>  <span className='primary'>{invoicedata && invoicedata.invoiceID}</span></li>
                          <li key="invoice-date"><p>Invoice Date</p>  {invoicedata && invoicedata.invoiceDate}</li>
                          <li key="due-date"><p>Due Date</p> {invoicedata && invoicedata.dueDate}</li>
                          {/* {invoicedata.description !="" &&<li key="total"><p>Description</p>{invoicedata && invoicedata.description}</li>} */}
                          {/* <li key="subtotal"><p>Subtotal</p>{invoicedata.currencyLabel} {invoicedata && invoicedata.subtotal}</li>
                          <li key="tax"><p>{invoicedata.taxLabel}</p> {invoicedata.currencyLabel} {invoicedata && invoicedata.taxamount}{invoicedata.tax_percentage && ` (${invoicedata.tax_percentage}%)`}</li> */}
                          <li key="total"><p>Total</p>{invoicedata.currencyLabel}{invoicedata && invoicedata.total}</li>
                          <li key="card-brand"><p>Payment Type</p> {cardDetails.brand}</li>
                          <li key="card-number"><p>Card Number</p> **** **** {cardDetails.last4}</li>
                          {/* <li key="expiration-date"><p>Expiration Date</p> {cardDetails.exp_month}/{cardDetails.exp_year}</li> */}
                        </ul>
                      </div>
                    </div>
                    <div className="btn_align mt-2">
                      <button 
                        type="button" 
                        className="btn btn-outline-primary w-100" 
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <button 
                        type="button" 
                        id="confirmPaymentButton" 
                        className="btn btn-primary w-100"  
                        onClick={handleConfirmPayment}
                      >
                        OK
                      </button>
                    </div>
                      </>
                    }
                  </div>
                    </>
                  )}
                    {/* Payment Failure Modal */}
                  {showModal && (
                        <>
                    <div className="modal-header border-0 p-0">
                    <button 
                      type="button" 
                      className="close-btn" 
                      onClick={closeModal}
                    >
                      <span className="material-symbols-outlined">close</span>
                    </button>
                  </div>
                  <div className="modal-body p-sm-4 p-3 text-center payment-fail">
                       <img className='w-100' src={paymentfailed} alt="" />
                        <h2>Payment Failed</h2>
                        <p>{paymentError?.message}</p>
                        
                      </div>
                    </>
                  )}
                       
               
                </div>
              </div>
            </Modal>
        </div>
    );
};

export default CheckoutForm;